import {
  Drawer, DrawerBody,
  DrawerOverlay, DrawerContent, DrawerHeader, Flex, FormControl, Text
} from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { MdClose } from 'react-icons/md'
import { ButtonCmp } from '../../../../../components/ButtonCmp'
import { SelectCmp } from '../../../../../components/SelectCmp'
import { IDepartment, iNomeId } from '../../../../../interfaces'

export interface iFiltro {
  status?: string
  area?: string
  gestor?: string
}

interface iDrawProps {
  isOpen: boolean
  gestores: iNomeId[]
  areas: IDepartment[]
  onClose: () => void
  filtro?: iFiltro
  onFilter: (filtro: iFiltro) => void
}

export const DrawerFiltro: React.FC<iDrawProps> = ({ isOpen, onClose, onFilter, areas, gestores, filtro }) => {
  const [Filtro, setFiltro] = useState<iFiltro>({
    area: '',
    status: '',
    gestor: ''
  })

  useEffect(() => {
    if (filtro) {
      setFiltro(filtro)
    }
  }, [filtro])

  return (
        <Drawer
            isOpen={isOpen}
            placement='right'
            onClose={onClose}
            size={'sm'}
        >
            <DrawerOverlay />
            <DrawerContent>
                <DrawerHeader as={Flex} width={'100%'} justifyContent={'space-between'} borderBottom={'2px solid var(--c3)'}>
                    <Text>Filtros</Text>
                    <MdClose onClick={onClose} size={24} color={'var(--Red)'}/>
                </DrawerHeader>

                <DrawerBody>
                    <Flex gap={'1rem'} flexDir={'column'}>
                        <FormControl>
                            <SelectCmp title='Área' OnChange={(e) => setFiltro({ ...Filtro, area: e })} value={Filtro.area}>
                                <option value={''}>Todas</option>
                                {
                                    areas.map((e, i) => {
                                      return (
                                        <option key={i} value={e.id}>{e.nome}</option>
                                      )
                                    })
                                }
                            </SelectCmp>
                        </FormControl>

                        <FormControl>
                            <SelectCmp title='Gestor' OnChange={(e) => setFiltro({ ...Filtro, gestor: e })} value={Filtro.gestor}>
                                <option value={''}>Todos</option>
                                {
                                    gestores.map((e, i) => {
                                      return (
                                            <option key={i} value={e.id}>{e.nome}</option>
                                      )
                                    })
                                }
                            </SelectCmp>
                        </FormControl>

                        <FormControl>
                            <SelectCmp title='Status' OnChange={(e) => setFiltro({ ...Filtro, status: e })} value={Filtro.status}>
                                <option value={''}>Todos</option>
                                <option value={'4'}>Em andamento</option>
                                <option value={'5'}>Concluído</option>
                            </SelectCmp>
                        </FormControl>

                        <Flex gap={'.5rem'} justifyContent={'end'}>
                            <ButtonCmp
                                VarColor='c6'
                                onClick={onClose}
                            >Cancelar
                            </ButtonCmp>
                            <ButtonCmp
                                VarColor='Green2'
                                onClick={() => onFilter(Filtro)}
                            >Filtrar
                            </ButtonCmp>
                        </Flex>
                    </Flex>
                </DrawerBody>
            </DrawerContent>
        </Drawer>
  )
}
